/* MARAYA: carry a claimed first-order code; Shopify remains the pricing/eligibility authority. */
(function () {
  'use strict';
  var CODE = 'WELCOME5';
  var CLAIM = 'mr_first_order_offer_claimed_v1';
  var OPT_OUT = 'mr_welcome_optout_v1';
  function uniqueCodes(values) {
    var seen = {};
    return values.reduce(function (all, value) {
      String(value || '').split(',').forEach(function (part) {
        var code = part.trim();
        if (code && !seen[code.toUpperCase()]) { seen[code.toUpperCase()] = true; all.push(code); }
      });
      return all;
    }, []);
  }
  function cartCodes(cart) {
    var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
    (cart.cart_level_discount_applications || []).forEach(function (entry) {
      var d = entry.discount_application || entry;
      if (d.type === 'discount_code') codes.push(d.title);
    });
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (a) {
        if (a.discount_application && a.discount_application.type === 'discount_code') codes.push(a.discount_application.title);
      });
    });
    return uniqueCodes(codes);
  }
  function checkoutCodes(existing, include, optedOut) {
    var codes = uniqueCodes(existing).filter(function (c) { return !optedOut || c.toUpperCase() !== CODE; });
    if (include && !optedOut) codes = uniqueCodes(codes.concat(CODE));
    return codes.join(',');
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { uniqueCodes: uniqueCodes, cartCodes: cartCodes, checkoutCodes: checkoutCodes };
    return;
  }
  if (window.MarayaWelcome) return;
  var configNode = document.getElementById('mr-welcome-config');
  var config = configNode ? JSON.parse(configNode.textContent) : {};
  var attempted = false, applying = false, removing = false, memoryOptOut = false;
  var lastCart = null, revision = 0, timer, removeError = false;
  function flag(key) {
    try { if (localStorage.getItem(key)) return true; } catch (_) {}
    return document.cookie.split(';').some(function (part) { return part.trim().indexOf(key + '=1') === 0; });
  }
  function optedOut() { return memoryOptOut || flag(OPT_OUT); }
  function wantsWelcome() { return !config.returningCustomer && flag(CLAIM) && !optedOut(); }
  function setOptOut() {
    memoryOptOut = true;
    try { localStorage.setItem(OPT_OUT, '1'); } catch (_) {}
    document.cookie = OPT_OUT + '=1; Max-Age=31536000; Path=/; SameSite=Lax';
  }
  function domCodes() {
    return Array.from(document.querySelectorAll('[data-minimog-cart-discounts] [data-discount-code]')).filter(function (node) {
      return !node.dataset.discountType || node.dataset.discountType === 'discount_code';
    }).map(function (node) { return node.dataset.discountCode; });
  }
  function isCartForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    try { return /\/cart\/?$/.test(new URL(form.action, window.location.href).pathname); } catch (_) { return false; }
  }
  function formCodes(form) {
    var values = Array.from(form.elements).filter(function (input) { return input.name === 'discount' && !input.disabled; }).map(function (input) { return input.value; });
    return checkoutCodes(domCodes().concat(values), wantsWelcome(), optedOut());
  }
  function prepareForm(form) {
    if (!isCartForm(form)) return;
    var value = formCodes(form);
    var input = form.querySelector('input[name="discount"]');
    if (!input && value) {
      input = document.createElement('input'); input.type = 'hidden'; input.name = 'discount'; input.dataset.mrWelcomeInput = 'true'; form.appendChild(input);
    }
    if (input && input.value !== value) input.value = value;
  }
  function paint() {
    var wanted = wantsWelcome();
    document.querySelectorAll('[data-mr-welcome-status]').forEach(function (node) {
      var saving = Number(node.dataset.saving) || 0;
      var count = Number(node.dataset.itemCount) || 0;
      var visible = count > 0 && (saving > 0 || wanted || removing);
      node.hidden = !visible;
      var title = saving > 0 ? 'WELCOME5 applied · Saved ' + node.dataset.savingLabel : (applying ? 'Applying WELCOME5…' : 'WELCOME5 saved for checkout');
      var note = removeError ? 'Could not remove the code. Please try Remove again.' : (saving > 0 ? 'First-order eligibility is confirmed at checkout.' : 'Your first-order code will be checked with your checkout details.');
      var titleNode = node.querySelector('[data-mr-welcome-title]');
      var noteNode = node.querySelector('[data-mr-welcome-note]');
      if (titleNode.textContent !== title) titleNode.textContent = title;
      if (noteNode.textContent !== note) noteNode.textContent = note;
      var button = node.querySelector('[data-mr-welcome-remove]');
      button.hidden = !visible; button.disabled = applying || removing;
    });
    document.querySelectorAll('[data-minimog-cart-discounts] [data-discount-code]').forEach(function (node) {
      if (node.dataset.discountCode.toUpperCase() === CODE) {
        var container = node.closest('.m-cart__summary');
        var status = container && container.querySelector('[data-mr-welcome-status]');
        if (status && !status.hidden) node.setAttribute('data-mr-welcome-managed', 'true');
        else node.removeAttribute('data-mr-welcome-managed');
      }
    });
    document.querySelectorAll('form').forEach(prepareForm);
  }
  function itemCount() {
    var node = document.querySelector('[data-mr-welcome-status]');
    return node ? Number(node.dataset.itemCount) : Number(config.itemCount || 0);
  }
  async function apply() {
    if (!wantsWelcome() || attempted || applying || removing || itemCount() === 0 || !window.MarayaCart) return;
    // Do not interfere with an in-progress add/remove/upgrade; try again at its completion event.
    if (document.querySelector('.mr-cart-transaction, #MinimogCartDrawer[aria-busy="true"], m-product-form.m-spinner-loading, [data-mr-cart-pending], #MrStickyAtcButton[data-loading="true"]')) return;
    attempted = true; applying = true; paint();
    try {
      var cart = lastCart || await MarayaCart.request('cart.js');
      var codes = cartCodes(cart);
      if (codes.some(function (code) { return code.toUpperCase() === CODE; })) return;
      var started = revision;
      var result = await MarayaCart.request('cart/update.js', { discount: uniqueCodes(codes.concat(CODE)).join(','), sections: MarayaCart.sections(), sections_url: window.location.pathname });
      lastCart = result;
      // If another cart update finished during the request, fetch current fragments instead of painting stale ones.
      await MarayaCart.refresh(started === revision ? result : null, false);
    } catch (_) {
      // No blind request retry. The synchronous checkout input still carries the claimed code.
    } finally { applying = false; paint(); }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(apply, 80); }
  async function remove() {
    if (applying || removing || !window.MarayaCart) return;
    setOptOut(); removing = true; removeError = false; paint();
    try {
      var cart = lastCart || await MarayaCart.request('cart.js');
      var remaining = cartCodes(cart).filter(function (code) { return code.toUpperCase() !== CODE; });
      var result = await MarayaCart.request('cart/update.js', { discount: remaining.join(','), sections: MarayaCart.sections(), sections_url: window.location.pathname });
      lastCart = result;
      await MarayaCart.refresh(result, false);
    } catch (_) {
      removeError = true;
    } finally { removing = false; paint(); }
  }
  document.addEventListener('submit', function (event) { prepareForm(event.target); });
  document.addEventListener('formdata', function (event) {
    if (!isCartForm(event.target)) return;
    var value = checkoutCodes(domCodes().concat(event.formData.getAll('discount')), wantsWelcome(), optedOut());
    if (value || event.formData.has('discount')) event.formData.set('discount', value);
  }, true);
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-mr-welcome-remove]')) { event.preventDefault(); remove(); }
    var nativeRemove = event.target.closest('[is="m-cart-discount-remove"]');
    var item = nativeRemove && nativeRemove.closest('[data-discount-code]');
    if (item && item.dataset.discountCode.toUpperCase() === CODE) { setOptOut(); paint(); }
  }, true);
  document.addEventListener('mr:welcome:claimed', function () { paint(); schedule(); });
  document.addEventListener('cart:updated', function (event) {
    revision++;
    var cart = event.detail && event.detail.cart;
    lastCart = cart && typeof cart.total_price === 'number' && Array.isArray(cart.items) ? cart : null;
    paint(); schedule();
  });
  window.addEventListener('storage', function (event) { if (event.key === CLAIM || event.key === OPT_OUT) { paint(); schedule(); } });
  window.MarayaWelcome = { refresh: paint };
  function init() { paint(); schedule(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
